'use client';
import dynamic from 'next/dynamic';
import React from 'react';

const Footer = dynamic(() => import('@letsgo/Footer').then((m: any) => m.Footer || m.default || m), { ssr: true });

export default function ClientFooter() {
  return <Footer />;
}

